const RWC_SAVING = 'RWC_SAVING'
const RWC_FETCHING_CODE = 'RWC_FETCHING_CODE'
const RWC_FETCHING_CODE_SUCCESS = 'RWC_FETCHING_CODE_SUCCESS'
const RWC_FETCHING_CODE_ERROR = 'RWC_FETCHING_CODE_ERROR'
const RWC_CLEAR_ERROR = 'RWC_CLEAR_ERROR'

export function saving () {
  return {
    type: RWC_SAVING
  }
}

export function fetchingCode() {
  return {
    type: RWC_FETCHING_CODE,
  }
}

export function fetchingCodeSuccess(code) {
  return {
    type: RWC_FETCHING_CODE_SUCCESS,
    code,
  }
}

export function fetchingCodeError(error) {
  return {
    type: RWC_FETCHING_CODE_ERROR,
    error,
  }
}

export function clearError() {
  return {
    type: RWC_CLEAR_ERROR,
  }
}

const initialState = {
  isSaving: false,
  isFetchingCode: false,
  isFetchingCodeError: '',
  code: null,
}

export function registerWithCode (state = initialState, action) {
  switch (action.type) {
    case RWC_CLEAR_ERROR :
      return {
        ...state,
        isFetchingCode: false,
        isFetchingCodeError: '',
        code: null,
      }
    case RWC_SAVING :
      return {
        ...state,
        isSaving: true,
      }
    case RWC_FETCHING_CODE :
      return {
        ...state,
        isFetchingCode: true,
      }
    case RWC_FETCHING_CODE_SUCCESS :
      return {
        ...state,
        isFetchingCode: false,
        code: action.code,
        isFetchingCodeError: '',
      }
    case RWC_FETCHING_CODE_ERROR :
      return {
        ...state,
        isFetchingCode: false,
        isFetchingCodeError: action.error,
      }
    default :
      return state
  }
}


// WEBPACK FOOTER //
// ./src/redux/modules/registerWithCode.js